import * as i18n from "i18next"
import intervalPlural from "i18next-intervalplural-postprocessor"
import { initReactI18next } from "react-i18next"

export type Language = "pl" | "en"

const defaultLanguage: Language = "pl"

async function loadTranslations() {
  const realm = process.env.REACT_APP_REALM
  let module
  if (realm === "LAW") {
    module = await import("./pl/Law.json")
  } else if (realm === "PUBLIC") {
    module = await import("./pl/Public.json")
  } else {
    module = await import("./pl/Accountancy.json")
  }
  return module.default
}

async function initI18n() {
  const translationData = await loadTranslations()
  await i18n
    .use(initReactI18next)
    .use(intervalPlural)
    .init({
      resources: {
        [defaultLanguage]: {
          translation: translationData
        }
      },
      lng: defaultLanguage,
      fallbackLng: defaultLanguage,
      ns: ["translation"],
      partialBundledLanguages: true,
      interpolation: { escapeValue: false }
    })
}

initI18n()

export default i18n
